import { httpWithAuth } from '~/clients';
import { CUSTOMER_JOURNEY_SERVICE } from '~/constants/endpoints';
import type { UserFinancing } from '~/contracts/vdp';
import { userFinancingQuery } from '~/queries';

type UserFinancingResponse = {
  data: { aCustomer: { financing: UserFinancing | null } };
};

export default async function fetchUserFinancing(
  userId: string,
  controller: AbortController
): Promise<UserFinancing | null> {
  return httpWithAuth
    .post<UserFinancingResponse>(
      CUSTOMER_JOURNEY_SERVICE,
      {
        query: userFinancingQuery,
        variables: { userId }
      },
      {
        headers: {
          'apollographql-client-name': process.env.npm_package_name ?? '',
          'apollographql-client-version': process.env.npm_package_version ?? ''
        },
        signal: controller.signal
      }
    )
    .then(res => res.data.data.aCustomer.financing);
}
